import { sygnet } from './sygnet'
import { logo } from './logo'
import { logoNegative } from './logo-negative'

import {
  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon,

  cilPlus,
  cilUser,
  cilLockLocked,
  cilApps,
  cilTv,
  cilTrash,
  cilLineWeight,
  cilArrowThickFromBottom,
  cilArrowThickFromTop,
  cilMinus,
  cilSave,
  cilPencil,
  cilSettings,
  cilScreenDesktop,
  cilNotes,
  cilAccountLogout,
  cilEnvelopeClosed,
  cilX,
  cilMediaPause,
  cilMediaPlay,
} from '@coreui/icons'

export const icons = Object.assign({}, {
  sygnet,
  logo,
  logoNegative
}, {
  cilPlus,
  cilUser,
  cilLockLocked,
  cilApps,
  cilTv,
  cilTrash,
  cilLineWeight,
  cilArrowThickFromBottom,
  cilArrowThickFromTop,
  cilMinus,
  cilSave,
  cilPencil,
  cilSettings,
  cilScreenDesktop,
  cilNotes,
  cilAccountLogout,
  cilEnvelopeClosed,
  cilX,
  cilMediaPause,
  cilMediaPlay,

  cilApplicationsSettings,
  cilSpeedometer,
  cilSun,
  cilMoon
})
